<template>
  <div
    class="content ht-100v pd-0"
    :style="{ height: finder ? 'calc(100vh - 60px)' : '100vh' }"
  >
    <div class="content-header">
      <div class="content-search">
        <feather type="search"></feather>
        <input
          type="search"
          class="form-control"
          placeholder="Динамик драйваас хайлт хийх"
        />
      </div>
      <div class="mg-l-auto">
        <a class="btn btn-outline-primary btn-xs d-flex align-items-center">
          <feather type="search" :size="13" class="mg-r-5"></feather>
          Хайх
        </a>
      </div>
    </div>
    <!-- content-header -->
    <div class="content-body pd-0">
      <div class="filemgr-wrapper filemgr-wrapper-two">
        <div class="filemgr-sidebar">
          <div class="filemgr-sidebar-header">
            <div class="dropdown dropdown-icon flex-fill">
              <button
                class="btn btn-xs btn-block btn-white"
                data-toggle="dropdown"
              >
                Шинэ <feather type="chevron-down"></feather>
              </button>
              <div class="dropdown-menu tx-13">
                <a class="dropdown-item"
                  ><feather type="folder"></feather><span>Хавтас</span></a
                >
                <div class="dropdown-divider"></div>
                <a class="dropdown-item"
                  ><feather type="file-text"></feather
                  ><span>Word документ</span></a
                >
                <a class="dropdown-item"
                  ><feather type="file-text"></feather><span>Powepoint</span></a
                >
                <a class="dropdown-item"
                  ><feather type="file-text"></feather
                  ><span>Excel хүснэгт</span></a
                >
              </div>
              <!-- dropdown-menu -->
            </div>
            <!-- dropdown -->
            <div class="dropdown dropdown-icon flex-fill mg-l-10">
              <button
                class="btn btn-xs btn-block btn-success"
                data-toggle="dropdown"
              >
                Хуулах <feather type="chevron-down"></feather>
              </button>
              <div class="dropdown-menu tx-13">
                <!-- <a @click="" class="dropdown-item"><feather type="file"></feather><span>Файл</span></a> -->
                <simple-uploader
                  :propObjectId="6"
                  :propObjectTypeId="6"
                  @on-success="init()"
                  class="wd-100p"
                >
                  <div slot="trigger" class="wd-100p">
                    <a slot="trigger" class="dropdown-item"
                      ><feather type="file"></feather><span>Файл</span></a
                    >
                  </div>
                </simple-uploader>
                <a
                  class="dropdown-item"
                  @click="showFileUploader()"
                  role="button"
                  ><feather type="file"></feather
                  ><span>Файл хуулах, үүсгэх</span></a
                >
              </div>
              <!-- dropdown-menu -->
            </div>
            <!-- dropdown -->
          </div>
          <!-- filemgr-sidebar-header -->
          <div
            class="filemgr-sidebar-body"
            style="max-height: calc(100vh - 115px); overflow: hiiden"
          >
            <div class="pd-t-20 pd-b-10 pd-x-10">
              <label
                class=" tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10"
                >Динамик драйв</label
              >
              <nav class="nav nav-sidebar tx-13">
                <a @click="resetFilter()" :class="`nav-link ${filterParams.folderId>=0?'active':''}`" role="button">
                  <feather type="folder"></feather> <span>Бүх файл</span>
                  <span v-show="filterParams.folderId>=0" class="text-white badge badge-primary">{{
                    counts.all
                  }}</span>
                </a>
                <!-- <a class="nav-link"
                  ><feather type="clock"></feather> <span>Сүүлд үзсэн</span></a
                >
                <a class="nav-link"
                  ><feather type="star"></feather> <span>Чухал файлууд</span></a
                > -->
                <a @click="filterParams.folderId=-1; pager.current = 1; init();" role="button" :class="`nav-link ${filterParams.folderId==-1?'active':''}`"
                  ><feather type="trash"></feather>
                  <span>Устгасан файлууд</span>
                  <span v-show="filterParams.folderId==-1" class="text-white badge badge-primary">{{
                    counts.all
                  }}</span>
                  </a
                >
              </nav>
            </div>
            <div class="pd-10">
              <label
                class=" tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10"
                >Файлын төрлөөр</label
              >
              <nav class="nav nav-sidebar tx-13">
                <vue-custom-scrollbar style="height: calc(100vh - 605px)">
                  <a
                    @click="filterExtension(e)"
                    :key="i"
                    v-for="(e, i) in counts.exts"
                    role="button"
                    class="nav-link"
                    :class="{ active: e.ext == filterParams.extension }"
                  >
                    <feather :type="`${e.icon}`"></feather>
                    <span>{{ e.ext }}</span>
                    <span
                      v-if="e.ext == filterParams.extension"
                      class="mg-l-auto"
                    >
                      <feather
                        type="x"
                        :size="13"
                        class="text-danger mx-n3"
                      ></feather>
                    </span>
                    <span v-else class="text-white badge badge-primary">{{
                      e.count
                    }}</span>
                  </a>
                </vue-custom-scrollbar>
              </nav>
            </div>
            <div class="pd-10">
              <label
                class=" tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10"
                >Үүсгэсэн огноогоор</label
              >
              <nav class="nav nav-sidebar tx-13">
                <a
                  @click="filterDates(e)"
                  :key="i"
                  v-for="(e, i) in filterParams.dateList"
                  role="button"
                  class="nav-link"
                  :class="{ active: e.m == filterParams.dateCur }"
                >
                  <feather type="calendar"></feather>
                  <span>{{ e.date }}</span>
                  <span v-if="e.m == filterParams.dateCur" class="mg-l-auto">
                    <feather
                      type="x"
                      :size="13"
                      class="text-danger mx-n3"
                    ></feather>
                  </span>
                </a>
              </nav>
            </div>
          </div>
          <!-- filemgr-sidebar-body -->
        </div>
        <!-- filemgr-sidebar -->

        <media-folders @on-folder-selected="folderSelected" />

        <div class="filemgr-content no-header has-footer">
          <!-- <div class="filemgr-content-header"></div> -->
          <div
            class="filemgr-content-body"
            style="overflow: auto; max-height: calc(100vh - 115px);"
          >
            <div class="pd-x-20 pd-y-10">
              <div class="row row-xs" v-if="attachments.length > 0">
                <file-item
                  @on-dropdown="mediaDropdown"
                  :activeId.sync="activeFileId"
                  :finder="finder"
                  @on-link="$emit('on-attach', $event)"
                  :fromCoreEdit="fromCoreEdit"
                  @on-setting="onSetting"
                  @on-delete="onDeleteConfirm"
                  @on-attach="showFile($event)"
                  role="button"
                  :colmd="2"
                  :obj="f"
                  v-for="(f, i) in attachments"
                  :key="i"
                ></file-item>
              </div>
              <div v-else>
                <div
                  class=" ht-100p d-flex flex-column align-items-center justify-content-center"
                  style="height: calc(100vh - 105px)"
                >
                  <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
                    <img src="assets/svg/folder.svg" class="img-fluid" alt="" />
                  </div>
                  <p class="tx-color-03 mg-b-10">Хоосон байна</p>
                  <div class="mg-b-40">
                    <a @click="resetFilter()" class="btn btn-white pd-x-30"
                      >Бүх файлыг харах</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filemgr-content-footer">
            <div>
              <div class="media">
                <feather type="database" stroke-width="1"></feather>
                <div class="media-body mg-l-10">
                  <!-- зөв тооцдог болох үед нээе -->
                  <!-- <div class="tx-12 mg-b-4">2.3GB used of 10GB</div> -->
                  <div class="progress ht-5">
                    <div
                      class="progress-bar wd-15p"
                      role="progressbar"
                      aria-valuenow="15"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
                <!-- media-body -->
              </div>
            </div>
            <div class="mg-l-auto">
              <b-pagination
                v-if="counts.all > 0"
                size="sm"
                align="center"
                v-model="pager.current"
                :total-rows="counts.all"
                :per-page="pager.perPage"
                @change="pageChanged"
                style="margin-bottom: 0"
              ></b-pagination>
            </div>
            <nav class="nav d-none d-sm-flex mg-l-auto">
              <span class="text-muted"
                >Нийт <b>{{ counts.all }}</b
                >.Харагдаж буй
                <span class="font-weight-bold">{{
                  (pager.current - 1) * pager.perPage + 1
                }}</span>
                -
                <span class="font-weight-bold">{{
                  (pager.current - 1) * pager.perPage + attachments.length
                }}</span>
              </span>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <file-dialog
      :show.sync="fileDialog.show"
      :id="fileDialog.id"
      swd="85vw"
      @on-hide="fileDialog.show = false"
    />

    <file-uploader
      @on-uploader-close="fileUploaderConfig.show = false"
      v-if="fileUploaderConfig.show"
      objectId="6"
      :objectTypeId="6"
      :mode="0"
      :boxId="0"
      @on-success="
        fileUploaderConfig.show = false;
        init();
      "
      :config="fileUploaderConfig"
    ></file-uploader>
    <file-settings
      :id="fileSetting.id"
      :obj="fileSetting.obj"
      @on-close="
        activeFileId = 0;
        fileSetting.id = null;
      "
    />

    <b-overlay :show="busy" no-wrap>
      <template #overlay>
        <div
          v-if="processing"
          class="p-4 text-center rounded bg-secondary text-light"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="p-3 text-center"
        >
          <p><strong id="form-confirm-label">Итгэлтэй байна уу?</strong></p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="busy = false"
            >
              Үгүй
            </b-button>
            <b-button variant="outline-success" @click="onDelete()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { mapActions } from "vuex";
const moment = require("moment");
import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    mediaFolders: () => ({
      component: import("@/views/modules/media/components/folder.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileItem: () => ({
      component: import("@/components/modules/media/item"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileSettings: () => ({
      component: import("@/components/modules/media/section/settings.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileUploader: () => ({
      component: import("@/components/modules/media/components/fileUploader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  mounted() {
    this.handleAside({ minimize: true, maximize: false });
    require("@/assets/scss/pages/filemgr.scss");
    //this.featherReplace();
    this.init();
  },
  // update(){
  //     this.featherReplace();
  // },
  beforeDestroy() {
    //this.handleAside({ minimize: false, maximize: true, filemgr: false });
  },
  props: {
    finder: {
      type: Boolean,
      default: () => false,
    },
    fromCoreEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      fileUploaderConfig: {
        show: false,
      },
      attachmentsCount: 0,
      attachments: [],
      extensions: [],
      counts: {
        all: 0,
        exts: [],
      },
      pager: {
        current: 1,
        perPage: 18,
      },
      fileDialog: {
        show: false,
        id: 0,
      },
      activeFileId: 0,
      filterParams: {
        folderId: null,
        extension: null,
        dateCur: null,
        dateList: [
          { date: "Энэ 7 хоногт", m: 1 },
          { date: "Энэ сард", m: 2 },
          { date: "Өнгөрсөн сард", m: 3 },
          { date: "Энэ жилд", m: 4 },
          { date: "Өнгөрсөн жилд", m: 5 },
        ],
        dateStart: null,
        dateEnd: null,
      },
      fileSetting: {
        id: null,
        boxId: null,
        obj: {},
      },
      processing: false,
      busy: false,
      processingId: 0,
    };
  },
  methods: {
    ...mapActions(["handleLoading", "handleAside"]),
    pageChanged(e) {
      this.pager.current = e;
      this.init();
    },
    showFileUploader() {
      this.fileUploaderConfig.show = true;
    },
    init() {
      this.handleLoading({ isLoading: true });
      request({
        params: {
          id: 0,
          folderId: this.filterParams.folderId,
          ext: this.filterParams.extension,
          startDate: this.filterParams.dateStart,
          endDate: this.filterParams.dateEnd,
          size: this.pager.perPage,
          skip: (this.pager.current - 1) * this.pager.perPage,
        },
        api: { method: "get", url: "Media/GetFolderInFileListBySkip" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          // request({
          //   params: {
          //     id: 0,
          //     folderId: this.filterParams.folderId,
          //     ext: this.filterParams.extension,
          //     startDate: this.filterParams.dateStart,
          //     endDate: this.filterParams.dateEnd,
          //   },
          //   api: { method: "get", url: "Media/getCounts" },
          //   store: this.$store,
          // }).then((res) => {
          //   if (res != false) {
          //     //console.log('res.data.count', res.data.count);
          //     this.handleLoading({ isLoading: false });
              
          //     // this.$nextTick(()=>{
          //     //     this.featherReplace();
          //     // })
          //   }
          // });

          this.counts.all = res.data.count;
              this.counts.exts = res.data.extensionList?.map(function(e) {
                let icn = "file";
                switch (e.ext) {
                  case "jpg":
                  case "svg":
                  case "png":
                    icn = "image";
                    break;
                  case "docx":
                  case "doc":
                    icn = "file";
                    break;
                  case "txt":
                  case "text":
                    icn = "file-text";
                    break;
                  default:
                    break;
                }
                e.icon = icn;
                return e;
              });
              //     this.$nextTick(()=>{
              //     this.featherReplace();
              // })
              this.handleLoading({ isLoading: false });
          this.attachmentsCount = res.data.count;
          //console.log(res.data.files);
          this.attachments = res.data.files.map(function(e) {
            let ext = e.e;
            var lastInd = e.link.lastIndexOf("?");
            e.l = e.link.substring(0, lastInd);
            e.dt = e.date;
            e.ex = e.e;
            e.s =
              e.size > 1024
                ? (e.size / 1024 / 1024).toFixed(2) + "MB"
                : (e.size / 1024).toFixed(2) + "KB";
            var lastIndex = e.title.lastIndexOf(".");
            e.t = e.title.substring(0, lastIndex);
            switch (e.title.substring(lastIndex + 1)) {
              case "jpg":
              case "jpeg":
              case "png":
              case "svg":
                ext = "image";
                break;
              case "doc":
              case "docx":
                ext = "word";
                break;
              case "xls":
              case "xlsx":
                ext = "excel";
                break;
              case "ppt":
              case "pptx":
                ext = "powerpoint";
                break;
              case "txt":
                ext = "alt";
                break;
              case "html":
              case "css":
              case "js":
                ext = "code";
                break;
              case "mp4":
                ext = "video";
                break;
              case "mp3":
                ext = "audio";
                break;
              case "pdf":
                ext = "pdf";
                break;
              default:
                break;
            }
            e.ext = ext;
            return e;
          });
        }
      });
    },
    showFile(id) {
      // if(this.finder){
      //     this.$emit('on-attach', id);
      // }else{
      //     this.fileDialog.id = id;
      //     this.fileDialog.show = true;
      // }
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    mediaDropdown(e) {
      if (this.activeFileId != e.id) this.activeFileId = e.id;
      else this.activeFileId = 0;
    },
    onSetting(e) {
      this.fileSetting.id = e.id;
      this.fileSetting.obj = e;
    },
    onDeleteConfirm(e) {
      this.processingId = e.id;
      this.busy = true;

      this.activeFileId = 0;
      this.fileSetting.id = null;
    },
    onDelete() {
      this.processing = true;
      request({
        data: { id: this.processingId },
        api: { method: "post", url: "Media/FileDelete" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.processing = false;
          this.busy = false;
          this.init();
        }
      });
    },
    folderSelected(e) {
      this.filterParams.folderId = e.id;
      this.init();
    },
    filterExtension(e) {
      this.filterParams.extension =
        this.filterParams.extension == e.ext ? null : e.ext;
      this.init();
    },
    filterDates(e) {
      if (this.filterParams.dateCur == e.m) {
        this.filterParams.dateCur = null;
        this.filterParams.dateStart = null;
        this.filterParams.dateEnd = null;
      } else {
        this.filterParams.dateCur = e.m;
        if (e.m == 1) {
          this.filterParams.dateStart = moment()
            .startOf("week")
            .add("d", 1)
            .format("YYYY/MM/DD");
          this.filterParams.dateEnd = moment().format("YYYY/MM/DD");
        } else if (e.m == 2) {
          this.filterParams.dateStart = moment()
            .startOf("month")
            .format("YYYY/MM/DD");
          this.filterParams.dateEnd = moment().format("YYYY/MM/DD");
        } else if (e.m == 3) {
          this.filterParams.dateStart = moment()
            .startOf("month")
            .add(-1, "M")
            .format("YYYY/MM/DD");
          this.filterParams.dateEnd = moment()
            .endOf("month")
            .add(-1, "M")
            .format("YYYY/MM/DD");
        } else if (e.m == 4) {
          this.filterParams.dateStart = moment()
            .startOf("year")
            .format("YYYY/MM/DD");
          this.filterParams.dateEnd = moment().format("YYYY/MM/DD");
        } else if (e.m == 5) {
          this.filterParams.dateStart = moment()
            .startOf("year")
            .add(-1, "Y")
            .format("YYYY/MM/DD");
          this.filterParams.dateEnd = moment()
            .endOf("year")
            .add(-1, "Y")
            .format("YYYY/MM/DD");
        } else {
          this.filterParams.dateStart = null;
          this.filterParams.dateEnd = null;
        }
      }

      this.init();
    },
    resetFilter() {
      this.pager.current = 1;
      this.filterParams.folderId = null;

      this.filterParams.extension = null;

      this.filterParams.dateCur = null;
      this.filterParams.dateStart = null;
      this.filterParams.dateEnd = null;

      this.init();
    },
  },
};
</script>

<style></style>
